// extracted by mini-css-extract-plugin
module.exports = {"marginRight":"ContentEstimateComponent_marginRight__1Xd0L","table":"ContentEstimateComponent_table__TaUEG","errorEstimate":"ContentEstimateComponent_errorEstimate__1j1gK"};